import React, { useEffect, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";
import newLogo from "../../assets/images/logo-2-circle.svg";

const QRModel = ({ couponId, onQRCodeGenerated }) => {
  const qrCode = new QRCodeStyling({
    data: couponId,
    qrOptions: {
      errorCorrectionLevel: "Q"
  },
    width: 400,
    height: 400,
    // image: "https://cdn.prod.website-files.com/66608e72bd63b75bb0b634e1/669ec1cc8c00526179356daa_Aletheia_Icon_wCircle_A%20(1)-p-500.png",
    image: newLogo,
    dotsOptions: {
      color: "#fa9e24",
      type: "dots"
    },
    backgroundOptions: {
      color: "#000"
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 1.5,
       hideBackgroundDots:true,
    },
    cornersSquareOptions:{
      type:"round"
  },
    cornersDotOptions:{
        type:"round"
    }
  });

  const ref = useRef(null);

  const getBase64Image = () => {
    const canvas = ref.current.querySelector("canvas");
    if (canvas) {
      const base64 = canvas.toDataURL("image/png");
      onQRCodeGenerated(base64);
    }
  };

  useEffect(() => {
    qrCode.update({ data: couponId });
    qrCode.append(ref.current);

    const timeout = setTimeout(() => {
      getBase64Image();
    }, 1000); // Delay to ensure QR code is rendered

    return () => clearTimeout(timeout);
  }, [couponId]);

  return (
    <div ref={ref} style={{display:"none"}} />
  );
};

export default QRModel;


// import React, { useEffect, useRef } from 'react';
// import { QRCode } from 'react-qrcode-logo';



// const QRModel = ({ onQRCodeGenerated,couponId}) => {
//   const qrRef = useRef(null);

//   // Convert the QR code to base64 once the component is mounted
//   useEffect(() => {
//     const canvas = qrRef.current.querySelector('canvas');
//     if (canvas) {
//       const base64Image = canvas.toDataURL('image/png');
//       console.log('QR Code Base64:', base64Image);
//       if (onQRCodeGenerated) {
//         onQRCodeGenerated(base64Image); // Pass the base64 image to the parent
//       }
//     }
//   }, [onQRCodeGenerated]);

//   return (
//     <div ref={qrRef} >
//       <QRCode
//         logoImage={'https://pd-filemanager.s3.us-west-2.amazonaws.com/pdlogo.svg'}
//         value={`${couponId} `}
//         size={400}
//         quietZone={20}
//         bgColor="#111111"
//         fgColor="#fa9e24"
//         ecLevel="M"
//         logoWidth={94}
//         logoHeight={96}
//         removeQrCodeBehindLogo={true}
//         qrStyle="dots"
//         logoPadding={0}
//         logoPaddingStyle="circle"
//         eyeRadius={[
//           { outer: [50, 50, 50, 50], inner: [50, 50, 0, 50] }, // top-left eye
//           { outer: [50, 50, 50, 50], inner: [50, 50, 50, 0] }, // top-right eye
//           { outer: [50, 50, 50, 50], inner: [50, 0, 50, 50] }, // bottom-left eye
//         ]}
//         enableCORS={false}
//       />
//     </div>
//   );
// };

// export default QRModel;
